import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core'
import { WidgetInterface } from '@modules/widgets-module/interfaces/widget.interface'
import { InfoComponent } from '../../info/info.component'

@Component({
	selector: 'app-info-widget',
	templateUrl: './info-widget.component.html',
	styleUrl: './info-widget.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [InfoComponent],
})
export class InfoWidgetComponent {
	public widget: InputSignal<WidgetInterface | null> = input<WidgetInterface | null>(null)
}
